import instObj from '@/backend/axios-instances'

const resource = "/materials"
const instance = instObj.baseInstance

export default {
  get(parameters) {
    return instance.get(resource, { params: parameters });
  },
  post(data, parameters) {
    return instance.post(resource, data, { params: parameters });
  },
  addImage(materialId, data) {
    return instance.post(`/material/${materialId}/image`, data);
  }
}
